import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Api} from '../../../smoothr-web-app-core/api/api';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject, Subscription} from 'rxjs';
import {axiosErrorToMessage, sleep} from '../../../smoothr-web-app-core/utils/utils';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import {FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {NavigationService, NAVIGATIONURLS} from 'src/app/services/navigation.service';
import {OrderUtils} from 'src/smoothr-web-app-core/utils/order-utils';
import {ValidationUtils} from 'src/smoothr-web-app-core/utils/validation-utils';
import {NavController} from '@ionic/angular';
import {MapsUtils} from 'src/maps/utils/maps';
import RepositoryDirective from 'src/smoothr-web-app-core/directives/repository-directive';

export enum Registration {
	SIGN_IN = 'signIn',
	SIGN_UP = 'signUp'
}

@Component({
	selector: 'app-account',
	templateUrl: './account.page.html',
	styleUrls: ['account.page.scss']
})
export class AccountPage extends RepositoryDirective {
	static url = 'account';
	mode = Registration.SIGN_IN;

	showRePassword = false;
	showPassword = false;

	venue: Venue;

	email = 'email';
	fullName = 'fullName';
	phone = 'phone';
	RegistrationEnum = Registration;
	separateDialCode = false;

	password = 'password';
	rePassword = 'rePassword';
	street = 'street';
	houseNumber = 'houseNumber';
	postcode = 'postcode';
	city = 'city';

	loading = false;

	signUpForm: FormGroup;

	private readonly subscription: Subscription;
	public accountMode$ = new BehaviorSubject(false);
	constructor(
		private translate: TranslateService,
		private route: ActivatedRoute,
		public repository: RepositoryService,
		private snackbarCtrl: MatSnackBar,
		private fb: FormBuilder,
		private router: Router,
		private navigationService: NavigationService,
		private navCtrl: NavController
	) {
		super(repository);
		if (repository.customer && !repository.customer.isAnonymous) {
			// this.navigationService.account();
			// this.accountMode$.next(true);
			// this.mode = Registration.SIGN_UP;
		}
	}
	onCustomer(): void {}
	ngOnInit() {
		super.ngOnInit();
		if (this.router.url.includes('account')) {
			this.accountMode$.next(true);
			this.mode = Registration.SIGN_UP;
			this.createFormSignUp();
		}
		this.route.queryParams.subscribe(params => {
			if (params?.auth === Registration.SIGN_IN) {
				this.mode = Registration.SIGN_IN;
				this.accountMode$.next(false);
			}
			if (params?.auth === Registration.SIGN_UP) {
				this.mode = Registration.SIGN_UP;
				this.accountMode$.next(false);
			}
		});
		console.log(this.mode);
		this.createFormSignUp();
	}

	createFormSignUp() {
		const formControlNames: any = {};
		formControlNames[this.phone] = [''];

		if (this.mode === Registration.SIGN_UP) {
			formControlNames[this.fullName] = ['', [Validators.required, Validators.pattern(/\w+\s\w+/)]];
			formControlNames[this.email] = [
				'',
				[
					Validators.required,
					Validators.pattern(
						"^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
					)
				]
			];
			formControlNames[this.phone] = [''];
			if (!this.accountMode$.value) {
				formControlNames[this.password] = [
					'',
					[Validators.required, Validators.minLength(8), Validators.pattern(/\d+/), Validators.pattern(/[A-Z]+/)]
				];

				formControlNames[this.rePassword] = ['', [Validators.required, this._isPasswordMatch()]];
			}

			formControlNames[this.street] = [''];
			formControlNames[this.houseNumber] = [''];
			formControlNames[this.postcode] = [''];
			formControlNames[this.city] = [''];
		}

		if (this.mode === Registration.SIGN_IN) {
			// formControlNames[this.fullName] = [''];
			formControlNames[this.email] = [''];
			formControlNames[this.password] = [
				'',
				[Validators.required, Validators.minLength(8), Validators.pattern(/\d+/), Validators.pattern(/[A-Z]+/)]
			];
		}
		this.signUpForm = this.fb.group(formControlNames);
		if (this.accountMode$.value) {
			console.log(this.customer);
			this.signUpForm.patchValue({
				fullName: this.customer.name,
				email: this.customer.email,
				phone: this.customer.phone,
				street: this.customer.street,
				houseNumber: this.customer.number,
				postcode: this.customer.postalCode,
				city: this.customer.city
			});
		}
	}

	private _isPasswordMatch(): ValidatorFn {
		return () => {
			const pass = this.signUpForm?.get('password')?.value;
			const confirmPass = this.signUpForm?.get('rePassword')?.value;
			return pass === confirmPass ? null : {notSame: true};
		};
	}

	isValid(controlName?: string): boolean {
		if (controlName) {
			return this.signUpForm.get(controlName)?.hasError('required') && this.signUpForm.get(controlName)?.touched;
		}

		return this.signUpForm?.invalid;
	}

	isValidByPattern(controlName?: string): boolean {
		if (controlName) {
			return this.signUpForm.get(controlName)?.errors && !this.signUpForm.get(controlName)?.hasError('required');
		}
		return this.signUpForm?.invalid;
	}

	getControlValue(controlName?: string) {
		if (controlName) {
			return this.signUpForm?.get(controlName)?.value;
		}
		return '';
	}

	ngOnDestroy() {
		super.ngOnDestroy();
		if (this.subscription && !this.subscription.closed) {
			this.subscription.unsubscribe();
		}
	}
	async checkAdress(): Promise<boolean> {
		// this.order.preorder.street = this.order.preorder.street.trim();
		// this.order.preorder.number = this.order.preorder.number.trim();
		const street = this.signUpForm.get('street')?.value;
		const number = this.signUpForm.get('houseNumber')?.value;
		const postalCode = this.signUpForm.get('postcode')?.value;
		const city = this.signUpForm.get('city')?.value;
		if (!street || !number || !postalCode || !city) {
			this.snackbarCtrl.open(this.translate.instant('address.street'), null, {
				duration: 2000
			});
			return false;
		}
		try {
			const pred = street + ' ' + number + ', ' + city + ' ' + postalCode;
			const address = await MapsUtils.getPlace(pred);
			const addressValidationResult = ValidationUtils.validateAddress(address, true);
			if (addressValidationResult) {
				console.log(this.translate.instant(addressValidationResult));
				this.snackbarCtrl.open(this.translate.instant(addressValidationResult), null, {
					duration: 2000
				});
				return false;
			}
			this.repository.address.emit(address);
			return true;
		} catch (e) {
			this.snackbarCtrl.open('errors.street_not_found', null, {
				duration: 2000
			});
			return false;
		}
	}
	async signUp() {
		// const checkAdress = await this.checkAdress();
		// if (!checkAdress) {
		// 	return false;
		// }
		if (!this.loading) {
			this.loading = true;
			try {
				await Api.signUpWithCredentials(
					{
						name: this.getControlValue('fullName'),
						email: this.getControlValue('email'),
						phone: this.getControlValue('phone')?.internationalNumber,
						street: this.getControlValue('street'),
						postalCode: this.getControlValue('postcode'),
						city: this.getControlValue('city'),
						number: this.getControlValue('houseNumber'),
						preferredVenues: []
					},
					this.getControlValue('password')
				);
				await this.navigationService.emailConfirmation();
			} catch (e) {
				if (e.response.data.name === 'UserAlreadyExistsError') {
					this.snackbarCtrl.open('User already exists');
				}
				this.snackbarCtrl.open(axiosErrorToMessage(this.translate, e));
			}
			this.loading = false;
		}
	}
	async signIn() {
		this.loading = true;
		try {
			const response = (
				await Api.signInWithCredentials(this.getControlValue('email'), this.getControlValue('password'))
			).data;
			this.repository.customerAuth.emit(response);
			await sleep(200);

			this.navCtrl.back();
			this.snackbarCtrl.open(this.translate.instant('sign_in.success'), null, {
				duration: 5000
			});
			await sleep(400);
			console.log('HERE');
			window.location.reload();
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('sign_in.error'), null, {
				duration: 5000
			});
			console.error(e);
		}
		this.loading = false;
	}

	goBack() {
		this.navigationService.menu();
	}

	setUpModeSignIn() {
		this.mode = Registration.SIGN_IN;
		this.createFormSignUp();
	}

	setUpModeSignUp() {
		this.mode = Registration.SIGN_UP;
		this.createFormSignUp();
	}
	async update() {
		if (!this.customer) {
			this.snackbarCtrl.open(this.translate.instant('account.please_wait'), null, {
				duration: 2000
			});
			return;
		}
		this.loading = true;
		const updatedCustomer = this.customer;
		updatedCustomer.name = this.getControlValue('fullName');
		updatedCustomer.email = this.getControlValue('email');
		updatedCustomer.phone = this.getControlValue('phone');
		updatedCustomer.street = this.getControlValue('street');
		updatedCustomer.postalCode = this.getControlValue('postcode');
		updatedCustomer.city = this.getControlValue('city');
		updatedCustomer.number = this.getControlValue('houseNumber');
		try {
			const response = await Api.patchCustomer(updatedCustomer);
			this.snackbarCtrl.open(this.translate.instant('account.success'), null, {
				duration: 2000
			});
			this.customer = response.data;
			this.repository._customerAuth.customer = this.customer;
			this.repository.customerAuth.emit(this.repository._customerAuth);
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('account.error'), null, {
				duration: 2000
			});
		}
		this.loading = false;
	}

	getErrorsForm(controlName) {
		if (controlName) {
			return this.signUpForm.get(controlName).errors;
		}

		return null;
	}
	showResetPasswordDialog() {}
	async logout() {
		try {
			this.repository.customerAuth.emit(null);
			this.order.subscriptions = [];
			this.order.orderedSubscriptionArticles = [];
			this.repository.order.emit(this.order);
			// window.location.reload();

			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_success'), null, {
				duration: 2000
			});

			await this.navigationService.navigateToUrlWithParams(NAVIGATIONURLS.signUp(), {auth: Registration.SIGN_IN});
		} catch (e) {
			// window.location.reload();
			await this.navigationService.navigateToUrlWithParams(NAVIGATIONURLS.signUp(), {auth: Registration.SIGN_IN});
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_error'), null, {
				duration: 2000
			});
		}
	}
}
